import PlatformActions from './PlatformActions'

export default class LUCKY365SLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Jungle',
      gameCode: 'LUCKY-SLOT-001',
      platform: 'LUCKY365',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // 1712174135408313672 / 1712174135408313673 / 1712174135408313674
      // roundId: NDQxNjk2MzgvMTcxMjE3NDEzNTQwODMxMzY3Mg== / NDQxNjk2MzgvMTcxMjE3NDEzNTQwODMxMzY3Mw== / NDQxNjk2MzgvMTcxMjE3NDEzNTQwODMxMzY3NA==
      // Base64 decode: 44169638/1712174135408313672 / 44169638/1712174135408313673 / 44169638/1712174135408313674
      roundId,
      betType: null,
      currency,
      betTime, // 2026-03-27T14:24:32.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: 0,
      updateTime,
      requireAmount: betAmount,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId,
      updateTime,
      betAmount,
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
